import React from 'react';
import {
  Row, Col,
  Card, CardBody
} from 'reactstrap';
import Ionicon from 'react-ionicons';

import './DetailCard.css';

const DetailCard = (props) => {
  const cols = props.cardObj.fields.map(f => <Col xl="3" md="12" xs="12">
    <div>{f.title}</div>
    {
      f.isArray ? <>{f.value &&
        <ol style={{ paddingLeft: '17px' }}>
          {
            f.value && f.value.map((item, i) => (
              <li className="text-capitalize"><b>{item}</b></li>
            ))
          }
        </ol>
      }
      </> :
        <>{f.value && <div><b className={(f.title !== 'Email Address' &&
          f.title !== 'Facebook Page' && f.title !== 'Instagram Page' &&
          f.title !== 'Website') ? 'text-capitalize' : ''}>{f.value}</b></div>}</>
    }
    {!f.value && <div><b>--</b></div>}
    <br />
  </Col>);


  return <Card id="detail-card">

    <CardBody>
      <Row className="header-border">
        <Col xl="10" md="10" xs="10">
          <b>{props.cardObj.title}</b>
        </Col>
        {props.from !== 'fmDetailPage' ? <Col xl="2" md="2" xs="2" className="text-align-right cursor-pointer" onClick={props.makeEditActive.bind(this, props.cardObj.edit, true)}>
          <Ionicon icon="md-create" fontSize="24px" color="#fdbb1f" />
        </Col> : ''}
      </Row>
      {/* <hr /> */}
      <Row className="content-padding">
        {cols}
      </Row>
      {
        (props.is_error) && (
          <Row className="content-padding">
            <Col xl="12" md="12" xs="12">
              <div className="error" style={{ fontSize: '15px' }}>*Some mandatory fields are not filled yet. Please edit data and provide all mandatory data.</div>
            </Col>
          </Row>)
      }
    </CardBody>
  </Card>;
};

export default DetailCard;